export class FindProjectGroupProjectRoleAction {
  public static readonly type =
    '[Authorisation] FindProjectGroupProjectRoleAction';
  constructor(
    public readonly userId: string,
    public readonly projectId: string,
  ) {}
}
